import React, { Component } from "react";
import Slide from "react-reveal";

class Resume extends Component {
  getRandomColor() {
    let letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  render() {
    const edu = [
      { name: "Maharishi International University, USA", degree: "Masters in Software Development", date: 'January 2021' },
      { name: "Arbaminch University, Ethiopia", degree: "Bachelores Degree in Electrical And Computer Engineering", date: 'July 2019' }]
    const education = edu.map(function (education) {
      return (
        <div key={education.name}>
          <h3>{education.name}</h3>
          <p className="info">
            {education.degree}<span>&bull;</span>
            <em className="date">{education.date} </em>
          </p>
        </div>
      );
    });
    const wor = [
      {
        company: "NAS Food PLC", title: "Electrical Engineer and technician", years: "FEB 2018-August 2019",
        description: "Worked in as technical supervisor in the electrical department and worked with different operating system machineries."
      }]
    const work = wor.map(function (work) {
      return (
        <div key={work.company}>
          <h3>{work.company}</h3>
          <p className="info">
            {work.title}
            <span>&bull;</span> <em className="date">{work.years}</em>
          </p>
          <p>{work.description}</p>
        </div>
      );
    });

    const allSkill = [
      { name: 'JavaScript', level: '93%' },
      { name: 'MongoDB', level: '80%' },
      { name: 'NodeJs', level: '85%' },
      { name: 'ReactJs', level: '90%' },
      { name: 'React Native', level: '84%' },
      { name: 'Angular', level: '85%' },
      { name: 'Web Service', level: '75%' },
      { name: 'SQL', level: '87%' },
    ]
    const skills = allSkill.map((skills) => {
      const backgroundColor = this.getRandomColor();
      const className = "bar-expand " + skills.name.toLowerCase();
      const width = skills.level;

      return (
        <li key={skills.name}>
          <span style={{ width, backgroundColor }} className={className}></span>
          <em>{skills.name}</em>
        </li>
      );
    });

    return (
      <section id="resume">
        <Slide left duration={1300}>
          <div className="row education">
            <div className="three columns header-col">
              <h1>
                <span>Education</span>
              </h1>
            </div>

            <div className="nine columns main-col">
              <div className="row item">
                <div className="twelve columns">{education}</div>
              </div>
            </div>
          </div>
        </Slide>

        <Slide left duration={1300}>
          <div className="row work">
            <div className="three columns header-col">
              <h1>
                <span>Work</span>
              </h1>
            </div>

            <div className="nine columns main-col">{work}</div>
          </div>
        </Slide>

        <Slide left duration={1300}>
          <div className="row skill">
            <div className="three columns header-col">
              <h1>
                <span>Skills</span>
              </h1>
            </div>

            <div className="nine columns main-col">
              <p>Below shows some of the programing languages I used in different projects.</p>

              <div className="bars">
                <ul className="skills">{skills}</ul>
              </div>
            </div>
          </div>
        </Slide>
      </section>
    );
  }
}

export default Resume;
